import { get } from "../Services/RestAPIService";

export const DEFAULT_PAGE_SIZE = 25;

export const fetchAllPages = async (buildUrl, pageSize = DEFAULT_PAGE_SIZE) => {
  const firstPage = await get(buildUrl(1, pageSize));
  

  if (Array.isArray(firstPage)) {
    return firstPage;
  }

  const firstResults = firstPage?.results || [];
  const totalPages =
    firstPage?.total_pages ||
    Math.ceil((firstPage?.count || firstResults.length) / pageSize) ||
    1;

  const remainingPages = await Promise.all(
    Array.from({ length: Math.max(totalPages - 1, 0) }, (_, index) =>
      get(buildUrl(index + 2, pageSize))
    )
  );

  const uniqueRows = new Map();
  [firstPage, ...remainingPages].forEach((page) => {
    (page?.results || []).forEach((row) => {
      if (!row) return;
      const key = row.id !== undefined ? row.id : Symbol("row");
      uniqueRows.set(key, row);
    });
  });

  return Array.from(uniqueRows.values());
};
